import { BackendCurrencyProvider, BackendLangProvider, toBackendLang } from "@kupikupi/api";
import { displayCurrencyForLocale } from "@kupikupi/money";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/**
 * Feeds the active i18next language into the framework-agnostic
 * `BackendLangProvider` so product hooks request localized titles + spec
 * names from the backend `lang` header (issue #54). `useTranslation` makes
 * `i18n.language` reactive, so switching language re-renders this and updates
 * the lang the product hooks send.
 */
export function BackendLangBridge({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  return (
    <BackendLangProvider lang={toBackendLang(i18n.language)}>
      <BackendCurrencyProvider currency={displayCurrencyForLocale(i18n.language)}>
        {children}
      </BackendCurrencyProvider>
    </BackendLangProvider>
  );
}
